import { useAuth } from '../contexts/AuthContext'
import { LoginButton } from './LoginButton'

export function LandingPage() {
  const { user, logout, isAuthenticated } = useAuth()

  return (
    <div className="min-h-screen bg-gradient-to-br from-discord-dark via-gray-900 to-gray-800">
      {/* Header */}
      <header className="container mx-auto px-4 py-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="text-4xl">🎮</div>
            <h1 className="text-2xl font-bold text-white">The Cartridge Blowers</h1>
          </div>
          {isAuthenticated && (
            <button
              onClick={logout}
              className="px-4 py-2 text-discord-gray hover:text-white transition-colors"
            >
              Logout
            </button>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <main className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center">
          {!isAuthenticated ? (
            <>
              <div className="text-7xl mb-8 animate-bounce">🎮</div>
              <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
                Welcome to the Cartridge Blowers portal
              </h2>
              <p className="text-xl text-discord-gray mb-12 max-w-2xl mx-auto">
                Log in to gain access to the Discord. Referral required.
              </p>
              <div className="flex justify-center">
                <LoginButton />
              </div>
            </>
          ) : (
            <>
              <div className="mb-8">
                {user?.avatar ? (
                  <img
                    src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png?size=128`}
                    alt={user.username}
                    className="w-32 h-32 rounded-full mx-auto border-4 border-discord-blurple shadow-lg"
                  />
                ) : (
                  <div className="w-32 h-32 rounded-full mx-auto bg-discord-blurple flex items-center justify-center text-5xl text-white font-bold shadow-lg">
                    {user?.username?.[0]?.toUpperCase()}
                  </div>
                )}
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                {user?.username}{(!user?.discriminator || user?.discriminator !== '0') ? '#'+user?.discriminator : ''}
              </h2>
              <p className="text-xl text-discord-gray mb-12">
                You're successfully logged in with Discord.
              </p>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 max-w-2xl mx-auto">
                <h3 className="text-2xl font-semibold text-white mb-4">Application Status</h3>
                <ul className="text-left text-discord-gray space-y-3 max-w-md mx-auto">
                  <li className="flex items-start gap-3">
                    {/* If they're here, they're active and logged in */}
                    <span className="text-discord-green mt-1">✓</span>
                    <span>Active Discord account</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-discord-green mt-1">✓</span>
                    <span>At least one trusted member has referred you</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-discord-green mt-1">✓</span>
                    <span>Member of The Cartridge Blowers Discord server</span>
                  </li>
                </ul>
              </div>
              <div className="mt-8">
                <a
                  href="/invites"
                  className="inline-block px-6 py-3 bg-discord-blurple hover:bg-discord-blurple/80 text-white rounded-lg transition-colors"
                >
                  View Invites
                </a>
              </div>
            </>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="container mx-auto px-4 py-8 mt-80">
        <div className="text-center text-discord-gray">
          <p>No sleep was harmed in the making of this website (that's a lie).</p>
        </div>
      </footer>
    </div>
  )
}
